import { IInterceptorIO, TInfoIO } from '../../../core/interceptor';
import { ResponseAPI } from '../../../adapters/api';

const NO_RESOURCE = 404;
const NO_CONTENT = 204;

const invalidResponses = [NO_RESOURCE, NO_CONTENT];

export class APIResponseNoContent implements IInterceptorIO<ResponseAPI> {
  readonly id = 'api-no_content';
  readonly type = 'response';

  async transform(infoIO: TInfoIO<ResponseAPI>) {
    const response = infoIO.packet.response;
    const hasInvalidStatus = invalidResponses.indexOf(response.status) >= 0;
    const hasNoContent = response.statusText === 'No Content';
    const isValid = !hasInvalidStatus && !hasNoContent;
    if (isValid) {
      return infoIO;
    }

    return {
      path: infoIO.path,
      options: infoIO.options,
      packet: {
        response,
        metadata: {},
        data: null
      }
    };
  }
}
